
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { JoinGroupDialog } from "./JoinGroupDialog";
import { Group } from "@/lib/types";

interface GroupJoinPromptProps {
  group: Group;
  onJoinGroup: () => Promise<void>;
}

export const GroupJoinPrompt = ({ group, onJoinGroup }: GroupJoinPromptProps) => {
  const [joining, setJoining] = useState(false);
  const [showJoinDialog, setShowJoinDialog] = useState(false);

  const handleJoinClick = () => {
    setShowJoinDialog(true);
  };

  const handleConfirmJoin = async () => {
    setJoining(true);
    try {
      await onJoinGroup();
    } catch (error) {
      console.error("Error joining group:", error);
    } finally {
      setJoining(false);
    }
  };

  return (
    <>
      <Card>
        <CardContent className="pt-6">
          <div className="text-center">
            <p className="mb-4">Join this group to see channels and participate in discussions.</p>
            <Button onClick={handleJoinClick} disabled={joining}>
              {joining ? "Joining..." : "Join Group"}
            </Button>
          </div>
        </CardContent>
      </Card>

      <JoinGroupDialog
        open={showJoinDialog}
        onOpenChange={setShowJoinDialog}
        group={group}
        onConfirm={handleConfirmJoin}
      />
    </>
  );
};
